<template>
	<nk-page :policyClaims="[]">
		<ag-grid :options="tableOptions" :data="errorList" ref="table" startup tabindex="101"></ag-grid>
	</nk-page>
</template>
<script lang="ts">
	import { defineComponent, PropType } from 'vue'
	import extend from 'lodash/extend'

	class Error {
		code!: string
		name!: string
		description!: string
	}

	export default defineComponent({
		name: 'product-import-errors',
		modal: {
			size: 'md',
			stateUID: 'modal-product-import-errors',
			helpTag: 'ProductImportErrors'
		},
		props: {
			data: { type: Object as PropType<Error[]>, required: true },
			options: {},
		},
		data() {
			return {
				settings: {
					mode: 'select',
				} as any,
				errorList: [] as Error[],
				tableOptions: {
					id: this.$options.name,
					focusAndSelect: {
						allowFocus: true
					},
					doubleClickedToSelect: true,
					enterToSelect: true,
					rowGroupPanelShow: false,
					groupIncludeTotalFooter: false,
					cellSelectionAggReport: false,
					pagination: false,
					fitToWidth: false,
					sideBar: 'none',
					rowSelection: {
						mode: 'singleRow'
					},
					columnDefs: [],

				} as any,

			}
		},
		created() {
			this.settings = extend({}, this.settings, this.options)
			this.errorList = this.data
			this.tableOptions.columnDefs = [...this.tableOptions.columnDefs, ...this.settings.columnDefs]
		},
		mounted() {
			this.prepareWindow(this.$t('sale.receipt-hawala.f.excel-import-errors-form'))
		},
		methods: {},
	})
</script>
<style></style>
